import React, { useEffect, useState } from 'react'
// import * as Helpers from '../helpers.mjs'
// import { fetchJson } from "../fetch.js"

const ClassSetOverlay = ({source, productImgSrc}) => {
    const { id, title } = source;
    
    const classSetOverlays = [
        "/assets/img/classSetOverlays/steel.png",
        "/assets/img/classSetOverlays/green.png",
        "/assets/img/classSetOverlays/aqua.png",
        "/assets/img/classSetOverlays/yellow.png",
        "/assets/img/classSetOverlays/red.png",
        "/assets/img/classSetOverlays/blue.png",
        "/assets/img/classSetOverlays/purple.png"
    ]
    

    const randomIndex = Math.floor(Math.random() * classSetOverlays.length)
    const randomClassSetOverlay = classSetOverlays[randomIndex]

    return (
        <div className="classSetOffer" key={id} title={title} alt={title} onError={(e) => {handleImageError(e.target)}}>
            <img className="productImg lazy bookImg testing" src={productImgSrc} />
            <div className="classSetOverlay">
                <img className="classSetOverlayImage" src={randomClassSetOverlay} alt="Class set offer" />
            </div>
        </div>        
    );
}

export default ClassSetOverlay;